import { Button } from "@/components/ui/button"
import { GENERIC_FIELD_TYPES } from "@/lib/care-plan-form-utils"
import { newFieldId } from "@/lib/care-plan-form-utils"

export function FieldPalette({ libraryItems = [], onAddField, onAddFromLibrary }) {
  return (
    <div className="space-y-4">
      <div>
        <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground mb-2">Tipuri câmp</p>
        <div className="flex flex-wrap gap-1">
          {GENERIC_FIELD_TYPES.map((t) => (
            <Button
              key={t.type}
              type="button"
              size="sm"
              variant="outline"
              className="text-xs rounded-full h-7"
              onClick={() =>
                onAddField({
                  id: newFieldId(),
                  type: t.type,
                  label: t.label,
                  required: false,
                })
              }
            >
              + {t.label}
            </Button>
          ))}
        </div>
      </div>
      {libraryItems.length > 0 && (
        <div>
          <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground mb-2">Bibliotecă</p>
          <ul className="space-y-1 max-h-[40vh] overflow-y-auto">
            {libraryItems.map((item) => (
              <li key={item.id}>
                <button
                  type="button"
                  className="w-full text-left text-xs px-2 py-1.5 rounded hover:bg-muted"
                  onClick={() => onAddFromLibrary(item)}
                >
                  {item.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}
